var React = require('react');
var Button = require('react-bootstrap').Button;
var Col = require('react-bootstrap').Col;
var Link = require('react-router').Link;
var Row = require('react-bootstrap').Row;
var Table = require('react-bootstrap').Table;
import PageHeader from '../Layout/PageHeader';

var Loading = require('../Loading');
var Invocation = require('../../api/Invocation');
var Address = require('../../util/Address');
var RealView = require('../ClientService/RealView');

var Service = React.createClass({
  render: function () {
    if (!this.props.services) {
      return <Loading />;
    }

    const client = this.props.services[this.props.params.clientId]

    if (!client) {
        return <Loading />;
    }

    const service = client.find(s => s.id == this.props.params.serviceId);

    if (!service) {
      return <Loading />;
    }

    return <RealView loading={false} service={service} upgradable={false} />;
  }
})
module.exports = Service;



// WEBPACK FOOTER //
// ./app/components/Partner/Service.js